<template>
    <b-container fluid>
        <b-row class="school-container-layout" id="support">
            <b-col cols="12" class="list-simulacros-content">
                <p class="list-simulacros-text-content">Elija uno de los grupos de Exámen Simulacro</p>
            </b-col>
            <b-col cols="12" class="mt-5" >
                <Simulacros :url="url"/>
            </b-col>
        </b-row>

    </b-container>
</template>
<script>
    import Simulacros from '@/components/Global/Report'

    export default {
        name: 'ResultsGroup',
        components: {Simulacros},
        data: () => ({
            url: 'ResultsGraficasGrupo'
        }),
        created() {
            this.$store.dispatch('setModulo', 'RESULTADOS POR GRUPO')
            this.$store.dispatch('setNav', true)
        },
        methods: {
            goRouter(url) {
                this.$router.push(url)
            },
            srcImagen(img) {
                let src = require('@/assets/images/' + img)
                return src
            }
        }
    }
</script>